<template>
	<v-card class="mb-3">
		<v-list-item>
			<v-list-item-content>
				<div @click="viewUpcomingBooking(booking)">
					<v-list-item-title class="secondary--text lighten-1 font-weight-bold">{{ booking.company.name }}</v-list-item-title>
					<v-list-item-subtitle class="black--text subtitle-2 font-weight-bold"
						>{{ dateFormattedMomentjs(booking.booking_dates[0]) }} to
						{{ dateFormattedMomentjs(booking.booking_dates[booking.booking_dates.length - 1]) }}</v-list-item-subtitle
					>

					<v-list-item-subtitle v-if="showTimes" class="pt-0 subtitle-2 black--text font-weight-bold">{{ start_time }} - {{ end_time }}</v-list-item-subtitle>
					<v-list-item-subtitle v-else-if="!showTimes" class="pt-0 subtitle-2 black--text font-weight-bold">Times differ per day</v-list-item-subtitle>

					<v-list-item-subtitle class="primary--text subtitle-2 font-weight-bold">#{{ booking.unique_booking_code }}</v-list-item-subtitle>
				</div>
				<v-row no-gutters>
					<v-badge :content="unreadMessageCount" :value="unreadMessageCount" color="primary" bottom overlap bordered>
						<v-btn
							v-if="showMessageValid(booking.booking_dates[booking.booking_dates.length - 1])"
							class="white--text button-rounded mt-2"
							:height="25"
							color="accent"
							@click="openMessageDialog()"
							><span style="font-size: 12px">Message</span></v-btn
						>
					</v-badge>
				</v-row>
			</v-list-item-content>

			<v-list-item-avatar>
				<v-icon large color="blue lighten-1" @click="viewUpcomingBooking(booking)">mdi-chevron-right</v-icon>
			</v-list-item-avatar>
		</v-list-item>
	</v-card>
</template>

<script>
import { mapActions } from 'vuex';
import { bus } from '@/main';
import moment from 'moment';

import store from '@/store';

export default {
	name: 'LocumUpcomingBookingCard',
	components: {},
	props: {
		booking: { type: Object, required: true },
	},

	data: () => ({
		showTimes: true,
		start_time: '',
		end_time: '',
		unreadMessageCount: 0,
	}),

	async mounted() {
		await this.getUnreadMessageCount();
		this.getTimes();
	},

	methods: {
		...mapActions('message', ['GetConversationUnreadCount']),
		viewUpcomingBooking(booking_request_set) {
			const {
				booking_dates,
				booking_dates_times,
				company,
				start_time,
				end_time,
				lunch,
				notes,
				id: bookingId,
				profession,
				rates,
				experience,
				accountid,
				skills,
				request_dates,
			} = booking_request_set;

			const booking = {
				start_time,
				end_time,
				lunch,
				notes,
				booking_dates,
				booking_dates_times,
				id: bookingId,
				profession,
				rates,
				experience,
				accountid,
				skills,
				request_dates,
			};
			store.dispatch('setLocumViewingPractice', { id: company.id, booking, source: 'viewUpcomingBooking' });
			bus.$emit('change-context', 'view-practice-details-card');
		},

		dateFormattedMomentjs(date) {
			return date ? moment(date).format('MMM Do YYYY') : '';
		},

		getTimes() {
			this.showTimes = true;
			this.start_time = this.booking.start_time;
			this.end_time = this.booking.end_time;
			for (let index = 0; index < this.booking.request_dates.length; index++) {
				if (
					moment(this.booking.request_dates[index].start_time).format('HH:mm') !== this.booking.start_time ||
					moment(this.booking.request_dates[index].end_time).format('HH:mm') !== this.booking.start_time
				) {
					this.showTimes = false;
					break;
				}
			}
		},

		openMessageDialog() {
			const sentByID = this.booking.professional.id;
			let receiverDetails = {
				id: this.booking.company.id,
				name: this.booking.company.name,
			};
			bus.$emit('show-message-dialog', receiverDetails, sentByID);
			this.unreadMessageCount = 0;
			bus.$emit('refresh-total-unread-message-count');
		},

		showMessageValid(reqEndDate) {
			const currentDate = new Date();
			const currentDayOfMonth = currentDate.getDate();
			const currentMonth = currentDate.getMonth(); // Be careful! January is 0, not 1
			const currentYear = currentDate.getFullYear();

			const dateString = currentYear + '-' + (currentMonth + 1).toString().padStart(2, '0') + '-' + currentDayOfMonth.toString().padStart(2, '0');
			if (reqEndDate >= dateString) return true;
			else return false;
		},

		async getUnreadMessageCount() {
			const unreadCount = await this.GetConversationUnreadCount({
				receivedByID: this.booking.professional.id,
				sentByID: this.booking.company.id,
			});
			this.unreadMessageCount = unreadCount;
		},
	},
};
</script>
